export const ELECTION_BEHAVIORS = Object.freeze({
  kv2014: behavior("kv2014", "kv", 2014, "Komunální volby 2014", true, true, false, false, false, false, true, true, true, true),
  kv2018: behavior("kv2018", "kv", 2018, "Komunální volby 2018", true, true, false, false, false, false, true, true, true, true),
  psp2017: behavior("psp2017", "psp", 2017, "Volby do PSP 2017", true, true, false, false, false, false, true, true, true, true),
  psp2021: behavior("psp2021", "psp", 2021, "Volby do PSP 2021", true, true, false, false, false, false, true, true, true, true),
  kv2022: behavior("kv2022", "kv", 2022, "Komunální volby 2022", true, true, false, false, false, true, true, true, true, true),
  psp2025: behavior("psp2025", "psp", 2025, "Volby do PSP 2025", true, true, false, false, false, true, true, true, true, true),
  kr2024: behavior("kr2024", "kr", 2024, "Krajské volby 2024", true, true, false, false, false, true, false, true, true, true),
  prez2023: behavior("prez2023", "prez", 2023, "Prezidentské volby 2023", true, true, false, true, true, false, false, true, true, true),
  sen2020: behavior("sen2020", "sen", 2020, "Volby do Senátu 2020", false, false, true, true, true, false, false, true, true, true),
  sen2022: behavior("sen2022", "sen", 2022, "Volby do Senátu 2022", false, false, true, true, true, false, false, true, true, true),
  sen2024: behavior("sen2024", "sen", 2024, "Volby do Senátu 2024", false, false, true, true, true, false, false, true, true, true),
});

function behavior(
  electionKey,
  family,
  year,
  displayName,
  isPrimaryOnboardingFamily,
  isAreaBased,
  isDistrictBased,
  isTwoRound,
  isCandidateResult,
  supportsCandidatesModule,
  supportsTrendsModule,
  supportsAnalytics,
  supportsTsunami,
  requiresOwnBoundary
) {
  return Object.freeze({
    election_key: electionKey,
    family,
    year,
    display_name: displayName,
    canonical_election_name: displayName,
    is_primary_onboarding_family: isPrimaryOnboardingFamily,
    is_area_based: isAreaBased,
    is_district_based: isDistrictBased,
    is_two_round: isTwoRound,
    is_candidate_result: isCandidateResult,
    supports_candidates_module: supportsCandidatesModule,
    supports_trends_module: supportsTrendsModule,
    supports_analytics: supportsAnalytics,
    supports_tsunami: supportsTsunami,
    requires_own_boundary: requiresOwnBoundary,
  });
}

function cleanKey(value) {
  return String(value || "").trim().toLowerCase();
}

export function getElectionBehavior(electionKey) {
  return ELECTION_BEHAVIORS[cleanKey(electionKey)] || null;
}

export function isCandidateResultElection(electionKey) {
  return Boolean(getElectionBehavior(electionKey)?.is_candidate_result);
}

export function isTwoRoundElection(electionKey) {
  return Boolean(getElectionBehavior(electionKey)?.is_two_round);
}

export function supportsCandidatesModule(electionKey) {
  return Boolean(getElectionBehavior(electionKey)?.supports_candidates_module);
}

export function supportsTrendsModule(electionKey) {
  return Boolean(getElectionBehavior(electionKey)?.supports_trends_module);
}

export function getPrimaryEntityLabel(electionKey) {
  return isCandidateResultElection(electionKey) ? "Kandidát" : "Strana";
}

export function parseAppElectionId(electionId) {
  const id = String(electionId || "").trim();
  let baseId = id;
  let typzastup = null;
  let electionRound = null;

  if (baseId.endsWith("_typ1")) {
    typzastup = 1;
    baseId = baseId.slice(0, -"_typ1".length);
  } else {
    const roundMatch = baseId.match(/^(.*)_k([12])$/);
    if (roundMatch) {
      baseId = roundMatch[1];
      electionRound = Number(roundMatch[2]);
    }
  }

  const parts = baseId.split("_").filter(Boolean);
  const electionKey = parts[0] || "";
  const behavior = getElectionBehavior(electionKey);
  if (typzastup === null && behavior?.family === "kv") typzastup = 2;

  return {
    id,
    election_key: electionKey,
    family: behavior?.family || null,
    type: behavior?.family || null,
    year: behavior?.year || null,
    area_slug: parts.length > 1 ? parts.slice(1).join("_") : null,
    typzastup,
    election_round: electionRound,
    sen_round: behavior?.family === "sen" ? electionRound : null,
    base_label: behavior?.display_name || electionKey,
    label: behavior?.display_name || electionKey,
  };
}

